module.exports = {
	"LANGUAGE": "Language",
	"HDR-obpa_fulltext_score": "Score",
	"HDR-obpa_name": "Name",
	"HDR-obpa_fulltext_summary": "Summary",
	"QUERY LIMIT REACHED": "There are more results than what is displayed. Please narrow your search criteria.",
	"NO DOCUMENTS FOUND": "No documents found.",
	"OPEN IN NEW WINDOW": "Open in New Window",
	"DOWNLOAD NATIVE": "Download in Native Format",
	"CLOSE": "Close",
	"SEARCH TYPE": "Search Type",
	"DOCUMENT TYPE": "Document Type",
	"SEARCH TERM": "Search Term",
	"SEARCH": "Search",
	"RESET": "Reset",
	"DATE": "Date",
	"FROM DATE": "From Date",
	"TO DATE": "To Date",
	"LOADING": "Loading...",
	"RETRY": "Retry",
	"ERROR": "Error!",
	"ERROR: QUERIES": "Unable to retrieve the list of search types.",
	"ERROR: DOCTYPES": "Unable to retrieve the list of Document Types.",
	"ERROR: KEYWORDS": "Unable to retrieve the list of search fields.",
	"ERROR: DOCUMENTS": "Unable to perform the requested search.",
	"FORM: INVALID FULLTEXT": "Field must be at least {{chars}} characters.",
	"FORM: INVALID DATE SHORT": "Format: {{format}} .",
	"FORM: REQUIRED KEYWORD": "Field is required.",
	"FORM: INVALID NUMERIC": "Field must be a number of up to {{digits}} digits.",
	"FORM: INVALID DATE": "Field must follow format {{format}} .",
	"FORM: INVALID CURRENCY": "Field must be a valid currency value.",
	"FORM: INVALID FLOAT": "Field must be a number.",
	"FORM: INVALID LENGTH": "Field must be at most {{chars}} characters.",
	"FORM: ERRORS": "There are errors on the form.",
	"FORM: noDate": "A date range must be specified.",
	"FORM: noKeyword": "At least one field must be specified.",
	"FORM: noDateOrKeyword": "A date range OR At least one field must be specified.",
	"FORM: noDateAndKeyword": "A date range AND At least one field must be specified."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/en.json
// module id = 352
// module chunks = 0